import getConfig from 'next/config';
import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

const { publicRuntimeConfig } = getConfig();

/* istanbul ignore next */
const basePath = publicRuntimeConfig.basePath
  ? publicRuntimeConfig.basePath
  : '';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: '48px',
    position: 'relative',
    backgroundColor: colors.black,
    borderRadius: '5px',
    backgroundImage: `url("${basePath}/assets/static/business-profile/ad-bg.png")`,
    backgroundRepeat: ' no-Repeat',
    backgroundPosition: '100%',
    backgroundSize: '400px 350px',
    padding: '40px 40px 40px 40px',
    [theme.breakpoints.down(1042)]: {
      padding: '36px 0 36px 40px',
    },
    [theme.breakpoints.down(910)]: {
      backgroundImage: 'none',
      paddingRight: '40px',
    },
  },
  procoreLogo: {
    [theme.breakpoints.down(910)]: {
      display: 'none',
    },
  },
  procoreEmblem: {
    [theme.breakpoints.up(910)]: {
      display: 'none',
      paddingTop: '30px',
    },
    [theme.breakpoints.down(910)]: {
      display: 'block',
      marginRight: '12px',
    },
  },

  logoAndHeadlineContainer: {
    alignItems: 'center',
    [theme.breakpoints.down(910)]: {
      alignItems: 'flex-start',
    },
  },
  headline: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '28px',
    color: colors.white,
    paddingBottom: '4px',
    [theme.breakpoints.down(348)]: {
      paddingBottom: '0px',
    },
  },
  subHeadline: {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: '36px',
    color: colors.white,
    marginTop: '20px',
  },
  text: {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '24px',
    color: colors.white,
    marginTop: '16px',
    marginBottom: '16px',
  },
  content: {
    maxWidth: '60%',
    [theme.breakpoints.down(1090)]: {
      maxWidth: '50%',
    },
    [theme.breakpoints.down(910)]: {
      maxWidth: '100%',
    },
  },
  adImageVariantA: {
    position: 'absolute',
    right: '0',
    top: '-21.3%',
    width: '330px',
    height: 'auto',

    [theme.breakpoints.down(1262)]: {
      top: '-7.4%',
    },
    [theme.breakpoints.down(1090)]: {
      top: '0.5%',
    },
    [theme.breakpoints.down(1042)]: {
      top: '-2%',
    },
    [theme.breakpoints.down(910)]: {
      display: 'none',
    },
  },
  adImageVariantB: {
    position: 'absolute',
    right: '-0.02%',
    width: '362.52px',
    height: 'auto',
    top: '-16.1%',

    [theme.breakpoints.down(1312)]: {
      top: '-6.7%',
    },
    [theme.breakpoints.down(1200)]: {
      width: '360px',
      top: '-6%',
    },
    [theme.breakpoints.down(1042)]: {
      top: '-9%',
    },
    [theme.breakpoints.down(974)]: {
      top: '3.1%',
    },
    [theme.breakpoints.down(971)]: {
      top: '9.8%',
    },
    [theme.breakpoints.down(910)]: {
      display: 'none',
    },
  },
}));
